import Add from '@mui/icons-material/Add';
import { API } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TableDisplay from '../../../common/TableDisplay';
import ConfirmModal from "../../../common/ConfirmModal";
import {CircularProgress} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {toast} from "react-toastify";

const mapStateToProps = state => ({
    ...state
})

const useStyles = makeStyles(
    theme => ({
        searchAndNavigation: {
            '& button[aria-label="Clear Search"]': {
                color: 'var(--colorTitle)',
                '&.Mui-disabled': {
                    color: 'var(--colorSubtitle)',
                },
            },
            '& input::placeholder': {
                color: 'var(--colorSubtitle)',
                opacity: 1,
            },
            '& .MuiTablePagination-root .MuiIconButton-root': {
                color: 'var(--colorTitle)',
            },
            '& .MuiTablePagination-root .MuiSelect-icon': {
                color: 'var(--colorTitle)',
            }
        },
    })
);

function PublicFeedbackBoard(props) {
    const classes = useStyles();
    const [publicFeedbackList, setPublicFeedbackList] = useState([]);
    const [linkGenerating, setLinkGenerating] = useState([]);
    const [linkDeleting, setLinkDeleting] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        API.get('Core', `/api/v1/public-feedback-board`)
            .then(r => {
                const sortedDataByCreatedAt = r.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setPublicFeedbackList(sortedDataByCreatedAt);
            });
    };

    let goToCreatePublicFeedback = () => {
        props.history.push(`/settings/create-public-feedback-board`,);
    }

    let goToEditPublicFeedback = (id) => {
        props.history.push(`/settings/edit-public-feedback-board/${id}`);
    }

    let generateNewLink = (id) => {
        API.post('Core', `/api/v1/public-feedback-board/${id}/refresh`)
            .then(() => {
                fetchData();
                toast('New link generated', { position: "top-center", type: "success" });
            })
            .catch(e => {
                console.error('Error generating new link ', e);
                toast(e.message, { position: "top-center", type: "error" })
            }).finally(() => {
            setLinkGenerating(linkGenerating.filter(linkID => linkID !== id));
        });
    }

    let deleteLink = (id) => {
        API.del('Core', `/api/v1/public-feedback-board/${id}`)
            .then(() => {
                fetchData();
                toast('Setting Deleted', { position: "top-center", type: "success" });
            })
            .catch(e => {
                console.error('Error deleting the setting ', e);
                toast(e.message, { position: "top-center", type: "error" })
            }).finally(() => {
            setLinkDeleting(linkDeleting.filter(linkID => linkID !== id));
        });
    }

    const copyLink = (datasource) => {
        var text = datasource;
        var elem = document.createElement("textarea");
        document.body.appendChild(elem);
        elem.value = text;
        elem.select();
        document.execCommand("copy");
        document.body.removeChild(elem);

        toast("Copied to clipboard!", { position: "top-center", type: "success" });
    }

    const COLUMNS = [
        { field: 'name',
          title: 'Name',
          customSort: (a, b) => (b.name.toLowerCase() < a.name.toLowerCase() ? -1 : 1)
        },
        {
            field: 'token', title: 'Link', sorting: false, render: d => {
                const feedbackUrl = `${window.location.protocol}//${window.location.hostname}/feedback-public/${d.token}`;
                return (
                    <div>
                        <a style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'underline' }}
                           target="_blank"
                           rel="noopener noreferrer"
                           href={feedbackUrl}>
                            {feedbackUrl}
                        </a>
                    </div>
                );
            }
        },
        {
            field: 'createdAt', title: 'Created', render: d => {
                return (<div>
                    {d.createdAt}
                </div>)
            }
        },
        {
            field: 'actions', title: 'Actions', sorting: false, render: d => {
                const feedbackLink = `${window.location.protocol}//${window.location.hostname}/feedback-public/${d.token}`;
                return (<div style={{ display: 'flex', alignItems: "center" }}>
                    <div className='addPublicFeedbackButton editMarginAdjustment' onClick={() =>goToEditPublicFeedback(d.id)}>
                        Edit
                    </div>
                    {!linkGenerating.includes(d.id) ?
                        <ConfirmModal
                            title={"This will deactivate the old link"}
                            text={(<span>Are you sure you want to generate a new link? The previous link will no longer be accessible.</span>)}
                            onConfirm={() => {
                                setLinkGenerating([...linkGenerating, ...[d.id]])
                                generateNewLink(d.id)
                            }}
                            confirmTitle={"Generate Link"}
                        >
                            <div className='addPublicFeedbackButton editMarginAdjustment'>
                                New Link
                            </div>
                        </ConfirmModal>
                        :
                        <CircularProgress size={18} />
                    }
                    {!linkDeleting.includes(d.id) ?
                        <ConfirmModal
                            title={"Delete Feedback Board"}
                            text={(<span>Are you sure you want to delete this Feedback Board? The URL associated with the setting will no longer be accessible.</span>)}
                            onConfirm={() => {
                                setLinkGenerating([...linkGenerating, ...[d.id]])
                                deleteLink(d.id)
                            }}
                            confirmTitle={"Delete"}
                        >
                            <div className='addPublicFeedbackButton editMarginAdjustment'>
                                Delete
                            </div>
                        </ConfirmModal>
                        :
                        <CircularProgress size={18} />
                    }
                    <div className='addPublicFeedbackButton editMarginAdjustment' onClick={()=>copyLink(feedbackLink)}>
                        Copy Link
                    </div>
                </div>);
            }
        },
    ];

    return (
        <div>
            <div className='addPublicFeedbackButton' onClick={goToCreatePublicFeedback}>
                <Add />
                Add Board
            </div>
            <div className={classes.searchAndNavigation}>
            <TableDisplay
                data={publicFeedbackList}
                title={props.title || 'Public Feedback Board'}
                columns={COLUMNS}
            />
            </div>
        </div>
    );
}

export default withRouter(connect(mapStateToProps)(PublicFeedbackBoard));